import { createAction } from '@reduxjs/toolkit';

const getEquipmentScheduleOrdersData = createAction('equipmentScheduleOrders/getEquipmentScheduleOrdersData');
const equipmentScheduleOrdersError = createAction('equipmentScheduleOrders/equipmentScheduleOrdersError');
// const deleteEquipmentScheduleOrder = createAction('equipmentScheduleOrders/deleteEquipmentScheduleOrder');
const updateEquipmentGroupsOrdersData = createAction('equipmentScheduleOrders/updateEquipmentGroupsOrdersData');
const updateEquipmentScheduleOrder = createAction('equipmentScheduleOrders/updateEquipmentScheduleOrder');

export default {
  getEquipmentScheduleOrdersData,
  equipmentScheduleOrdersError,
  // deleteEquipmentScheduleOrder,
  updateEquipmentGroupsOrdersData,
  updateEquipmentScheduleOrder,
};
